export enum ResourcesHttpPaths {
  policiesAndProcedures = '/api/v1.0/policies-and-procedures',
  downloadPolicyAndProcedure = '/api/v1.0/policies-and-procedures/get-file',
  nmcNmbiStatus = '/api/v1.0/staff/skills/loyalty',
  primaryAddress = '/api/v1.0/staff/addresses/primary',
  nmcNmbiSubmitQuery = '/api/v1.0/staff/skills/loyalty/submit-query',
  nmcNmbiClaimFee = '/api/v1.0/staff/skills/loyalty/claim',
  lastWorkedShifts = '/api/v1.0/staff/shifts/summaries/last-worked-shifts',
  submitComplaints = '/api/v1.0/complaints',
  isClaimMade = '/api/v1.0/staff/first-uniforms/is-claim-made',
  submitClaimUniformReimbursement = '/api/v1.0/staff/first-uniforms/claim',
}
